import { makeAuthenticatedRequest } from './api';

/**
 * List the current admin users. Super-admin only (the API enforces it).
 * @returns {Promise<{admins: Array}>}
 */
export const listAdminUsers = async () =>
  makeAuthenticatedRequest('/admin-users/list', { method: 'GET' });

/**
 * Create a new admin user. Super-admin only.
 * @param {{email: string, firstName: string, lastName: string}} payload
 * @returns {Promise<{uid, email, firstName, lastName, temporaryPassword}>}
 */
export const createAdminUser = async ({ email, firstName, lastName }) =>
  makeAuthenticatedRequest('/admin-users/create', {
    method: 'POST',
    body: { email, firstName, lastName },
  });
